import apiClient from '../../shared/services/apiClient';

const API_BASE = '/api/admin';

const currencyService = {
    // 获取所有货币列表（管理员）
    async getCurrencies() {
        const response = await apiClient.get(`${API_BASE}/currencies`);
        return response.data;
    },

    // 获取启用的货币列表（公开）
    async getEnabledCurrencies() {
        const response = await apiClient.get('/currencies');
        return response.data;
    },

    // 创建货币
    async createCurrency(data) {
        const response = await apiClient.post(`${API_BASE}/currencies/create`, data);
        return response.data;
    },

    // 更新货币
    async updateCurrency(data) {
        const response = await apiClient.post(`${API_BASE}/currencies/update`, data);
        return response.data;
    },

    // 删除货币
    async deleteCurrency(id) {
        const response = await apiClient.post(`${API_BASE}/currencies/delete`, { id });
        return response.data;
    },

    // 设置默认货币
    async setDefaultCurrency(id) {
        const response = await apiClient.post(`${API_BASE}/currencies/set-default`, { id });
        return response.data;
    },

    // 批量更新汇率
    async updateRates(rates) {
        const response = await apiClient.post(`${API_BASE}/currencies/update-rates`, { rates });
        return response.data;
    },
};

export default currencyService;
